import { render, staticRenderFns } from "./movmentBag.vue?vue&type=template&id=05b9ba60&"
import script from "./movmentBag.vue?vue&type=script&lang=js&"
export * from "./movmentBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports